// extracted by mini-css-extract-plugin
module.exports = {"subgoal":"Subgoal_subgoal__22uz0","arrow":"Subgoal_arrow__3EEb3","divider":"Subgoal_divider__ga1RX","disabled":"Subgoal_disabled__sqo2y"};